import React, { Component } from "react";
import Col from "react-bootstrap/Col";
import Form from "react-bootstrap/Form";
import Row from "react-bootstrap/Row";
import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";
import "../../../components/admin/css/common.css";
import sweetAlert, {
  sweetStatusAlert,
  sweetConfirmAlert
} from "../../../components/common/SweetAlert.js";
import Spinner from "react-bootstrap/Spinner";
import PageSpinner from "../../../components/common/spinner/PageSpinner.js";
import {
  Table,
  TableHead,
  TableRow,
  TableBody,
  TableCell
} from "@mui/material";
import MaterialCustomTablePagination from "../../../components/common/MaterialCustomTablePagination.js";
import debounce from "lodash.debounce";
import SimpleReactValidator from "simple-react-validator";
import { PaymentMethodService } from "../../../service/settings/manage/payment_method.service.js";
import ContentWrapper from "../../../components/common/ContentWrapper.js";
import config from '../../../helper/config.js';
import {customerConstants} from "../../../helper/constants.js";

const getCustomerFeatureFlag = () => {
  return config.customerConfigs.featureFlag;
};

let addBtnStyle, closeBtnStyle;
const customer = getCustomerFeatureFlag();
switch (customer) {
  case customerConstants.EXO_CUSTOMER1:
    break;
  case customerConstants.EXO_CUSTOMER2:
    closeBtnStyle = {
      color: "var(--maincolor-cmc)",
      backgroundColor: "#E5F5FF",
      borderColor: "transparent",
    };
    addBtnStyle = {
      color: "#fff",
      backgroundColor: "var(--maincolor-cmc)",
      borderColor: "transparent",
    };
    break;
  default:
    break;
}

export default class extends Component {
  constructor(props) {
    super(props);
    this.createValidationsInstance();
    this.state = {
      showModal: false,
      payment_method_id: "",
      name: "",
      description: "",
      payment_methods: [],
      isModified: false,
      showInsertModal: false,
      limit: 10, // Set the desired limit
      offset: 0, // Set the desired offset
      search_term: "",
      totalPaymentMethods: 10,
      isTableDataLoading: true,
      currentPage: 0,
      editVisibility: true,
      addVisibility: true,
      deleteVisibility: true,
      isLoading: false,
    };

    // Debounced version of handleSearch function
    this.debouncedHandleSearch = debounce(this.fetchPaymentMethodsData, 2000);
  }

  // Reset the form fields to initail values on update, insert, edit modal close and add modal close
  resetFormFields = () => {
    this.setState({
      name: "",
      description: "",
    });
  };

  componentDidMount() {
    this.fetchPaymentMethodsData();
  }

  // Creating validator instance without any custom rules
  createValidationsInstance() {
    this.validator = new SimpleReactValidator();
  }

  //fetching available payment_methods count for pagination using specific search_term
  fetchPaymentMethodsData = async () => {
    const { limit, offset, search_term } = this.state;
    await PaymentMethodService.getPaymentMethodByPagination(limit, offset, search_term)
      .then((response) => {
        if (response.success) {
          this.setState({
            payment_methods: response.data.payment_methods,
            totalPaymentMethods: parseInt(response.data.count),
          });
        } else {
          sweetStatusAlert(
            "Failed!",
            "Error fetching payment methods. Please refresh the screen!",
            "error"
          );
        }
      })
      .catch((error) => {
        // Handle any error that occurred during the API call
        sweetStatusAlert(
          "Failed!",
          "Error fetching payment methods. Please refresh the screen!",
          "error"
        );
      })
      .finally(() => {
        this.setState({ isTableDataLoading: false }); // Set isTableDataLoading to false after data is fetched
      });
  };

  // Handle the data fetching as per the offset(page no) changes
  handlePageChange = (event, newPage) => {
    const { limit } = this.state;
    const newOffset = newPage * limit;
    this.setState(
      {
        offset: newOffset,
        isTableDataLoading: true,
        currentPage: newPage,
      },
      () => {
        this.fetchPaymentMethodsData();
      }
    );
  };

  handlePageOffsetChange = (newOffset, newPage) => {
    this.setState(
      {
        offset: newOffset,
        isTableDataLoading: true,
        currentPage: newPage
      },
      () => {
        this.fetchPaymentMethodsData();
      }
    );
  };

  // handle the data fetching as per the data per page limit gets changess
  handleRowsPerPageChange = (event) => {
    const newLimit = parseInt(event.target.value, 10);
    const newPage = Math.floor(this.state.offset / newLimit);
    this.setState(
      {
        limit: newLimit,
        offset: newLimit * newPage,
        isTableDataLoading: true,
        currentPage: newPage,
      },
      () => {
        this.fetchPaymentMethodsData();
      }
    );
  };

  // handle search text as per the regex validation and search_term , and fetch data as per the debounce
  handleSearch = (event) => {
    const search_term = event.target.value.trim();
    const regex = /^[a-zA-Z0-9][a-zA-Z0-9@\s.&]*$/;

    if (search_term === "" || regex.test(search_term)) {
      this.setState(
        {
          search_term,
          isTableDataLoading: true,
          offset: 0,
          currentPage: 0,
          searchError: false,
        },
        () => {
          this.debouncedHandleSearch();
        }
      );
    } else {
      this.setState({ search_term, searchError: true });
    }
  };

  // Toggle out the state of add form modal
  toggleAddPaymentMethodModal = () => {
    this.setState((prevState) => ({
      showInsertModal: !prevState.showInsertModal,
    }));
  };

  // Toggle out the state of update form modal
  toggleUpdatePaymentMethodModal = (payment_method_id, name, description) => {
    this.setState((prevState) => ({
      showModal: !prevState.showModal,
      payment_method_id: payment_method_id,
      name: name,
      description: description,
    }));
  };

  // Toggle out the state of detail form modal
  togglePaymentMethodDetailsModal = () => {
    this.setState((prevState) => ({
      showDetailModal: !prevState.showDetailModal,
    }));
  };

  // Sets the value of a specific state based on the value provided to the respective element based on its assigned name
  handleChange = (event) => {
    const { name, value } = event.target;
    this.setState(() => ({ [name]: value, isModified: true }));
  };

  // Pop up a sweet alert on edit or add modal and change its toggle state based on the input given to that sweet alert
  handleSweetAlert = (toggleFunction, modalVisibility) => {
    if (this.state.isModified) {
      sweetAlert().then((response) => {
        this.validator.hideMessages();
        this.validator.purgeFields();
        this.resetFormFields();
        this.setState(() => ({
          [modalVisibility]: response,
          isModified: false,
        }));
      });
    } else {
      this.validator.hideMessages();
      this.validator.purgeFields();
      this.resetFormFields();
      toggleFunction();
    }
  };

  // Make post request based on the fields validity and create the subjects based on the state
  handleSubmit = async (event) => {
    event.preventDefault();

    if (!this.validator.allValid()) {
      this.validator.showMessages();
      this.forceUpdate();
    } else {
      this.setState({ isLoading: true });

      const { name, description } = this.state;
      const newPaymentMethod = { name: name, description: description };

      await PaymentMethodService.create(newPaymentMethod)
        .then((response) => {
          this.setState({ isLoading: false });
          if (response.success) {
            this.setState({ showInsertModal: false });
            sweetStatusAlert("Success!", response.message, "success");
            this.validator.hideMessages();
            this.validator.purgeFields();
            this.resetFormFields();
            this.fetchPaymentMethodsData();
          } else {
            sweetStatusAlert("Failed!", response.message, "error");
          }
        })
        .catch(() => {
          this.setState({ isLoading: false });
          sweetStatusAlert("Failed !", "Unable to create new payment method", "error");
        });
    }
  };

  // Make put request based on the fields validity and updation of necessary states
  handleUpdateSubmit = async (event) => {
    event.preventDefault();

    if (!this.validator.allValid()) {
      this.validator.showMessages();
      this.forceUpdate();
    } else {
      this.setState({ isLoading: true });

      const paymentMethodItem = {
        name: this.state.name,
        description: this.state.description,
      };

      const paymentMethodId = this.state.payment_method_id;
      await PaymentMethodService.update(paymentMethodItem, paymentMethodId)
        .then((response) => {
          this.setState({ isLoading: false });
          if (response.success) {
            this.setState({ showModal: false });
            sweetStatusAlert(
              "Success!",
              "payment method information updated successfully..!",
              "success"
            );
            this.validator.hideMessages();
            this.validator.purgeFields();
            this.resetFormFields();
            this.fetchPaymentMethodsData();
          } else {
            sweetStatusAlert("Failed!", response.message, "error");
          }
        })
        .catch((error) => {
          this.setState({ isLoading: false });
          sweetStatusAlert(
            "Failed !",
            "Unable to update the payment method information",
            "error"
          );
        });
    }
  };

  handleDeletePaymentMethod = (id) => {
    sweetConfirmAlert().then(() => {
      this.setState({ isLoading: true });
      PaymentMethodService.deletePaymentMethod(id)
        .then((response) => {
          this.setState({ isLoading: false });
          if (response.success) {
            sweetStatusAlert("Success!", response.message, "success");
            this.fetchPaymentMethodsData();
          } else {
            sweetStatusAlert(
              "Oops!",
              "This payment method is in use. You cannot delete it.",
              "info"
            );
          }
        })
        .catch((error) => {
          this.setState({ isLoading: false });
          sweetStatusAlert("Oops!", "Error while deleting the payment method", "info");
        });
    });
  };

  //Rendering the necessary components based on the logic
  render() {
    const {
      limit,
      payment_methods,
      totalPaymentMethods,
      isTableDataLoading,
      currentPage,
      editVisibility,
      addVisibility,
      deleteVisibility,
      isLoading,
    } = this.state;
    this.validator.purgeFields();
    return (
      <>
        <ContentWrapper>
          <div className="row justify-content-between align-items-center py-5 mb-3">
            <div className="col-md-6 col-6">
              <h3 className="text-nowrap">Manage payment method </h3>
            </div>
            <div>
              {addVisibility && (
                <Button
                  className="insert-btn"
                  variant="primary"
                  onClick={() => this.toggleAddPaymentMethodModal(true)}
                >
                  Manage Payment Method
                </Button>
              )}
            </div>
          </div>
          <div>
            <Form.Group controlId="exampleForm.ControlInput1" className="mb-2">
              <Form.Control
                type="text"
                placeholder="Search"
                onChange={this.handleSearch}
                isInvalid={this.state.searchError}
                // style={{ width: "18%" }}
                className="col-md-3 col-12"
              />
              {this.state.searchError && (
                <Form.Control.Feedback type="invalid">
                  Invalid input
                </Form.Control.Feedback>
              )}
            </Form.Group>
            {isLoading && (
              <PageSpinner id="show" text="Loading, Please wait!" />
            )}
            {isTableDataLoading ? (
              <div
                className="loading-container"
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  width: "75vw",
                  height: "90vh",
                }}
              >
                <Spinner animation="border" role="status">
                  <span className="sr-only">Loading...</span>
                </Spinner>
              </div>
            ) : payment_methods.length > 0 ? (
              <div style={{ width: "75vw", height: "90vh", overflow: "auto" }}>
                <Table>
                  <TableHead>
                    <TableRow>
                      <TableCell className="thead">No</TableCell>
                      <TableCell className="thead">Event type</TableCell>
                      <TableCell className="thead">Description</TableCell>
                      {(editVisibility || deleteVisibility) && (
                        <TableCell className="thead">Actions</TableCell>
                      )}
                    </TableRow>
                  </TableHead>

                  <TableBody>
                    {payment_methods.map((paymentMethodItem) => (
                      <TableRow key={paymentMethodItem.payment_method_id}>
                        <TableCell className="tData">
                          {paymentMethodItem.payment_method_id}
                        </TableCell>
                        <TableCell className="tData">
                          {paymentMethodItem.name}
                        </TableCell>
                        <TableCell className="tData">
                          {paymentMethodItem.description}
                        </TableCell>
                        {(editVisibility || deleteVisibility) && (
                          <TableCell>
                            <div className="btn-group">
                              {editVisibility && (
                                <Button
                                  onClick={() =>
                                    this.toggleUpdatePaymentMethodModal(
                                      paymentMethodItem.payment_method_id,
                                      paymentMethodItem.name,
                                      paymentMethodItem.description
                                    )
                                  }
                                  className="btn btn-icon btn-primary btn-sm m-1 edit-assement-btn flaticon-edit-icon"
                                  title="Edit Details"
                                />
                              )}
                              {deleteVisibility && (
                                <Button
                                  onClick={() =>
                                    this.handleDeletePaymentMethod(paymentMethodItem.payment_method_id)
                                  }
                                  className="btn btn-icon btn-danger btn-sm m-1 delete-assement-btn flaticon-delete"
                                  title="Delete"
                                />
                              )}
                            </div>
                          </TableCell>
                        )}
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
                <MaterialCustomTablePagination
                  totalCount = {totalPaymentMethods}
                  currentPage = {currentPage}
                  limit = {limit}
                  handlePageChange = {this.handlePageChange}
                  handleRowsPerPageChange = {this.handleRowsPerPageChange}
                  handlePageOffsetChange = {this.handlePageOffsetChange}
                  offset = {this.state.offset}
                  rowsPerPageOptions={[5, 10, 20]}
                />
              </div>
            ) : (
              <div
                className="text-center mb-5 mt-10"
                style={{ height: "90vh" }}
              >
                <label>No payment methods available!</label>
              </div>
            )}
          </div>
        </ContentWrapper>

        <Modal
          size="lg"
          aria-labelledby="contained-modal-title-vcenter"
          centered
          show={this.state.showInsertModal}
          onHide={() =>
            this.handleSweetAlert(this.toggleAddPaymentMethodModal, "showInsertModal")
          }
        >
          <Modal.Header closeButton>
            <Modal.Title>Create New Payment Method </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Form>
              <Row className="my-5">
                <Form.Group
                  as={Col}
                  md="6"
                  controlId="exampleForm.ControlInput1"
                >
                  <Form.Label>Payment Method Name*</Form.Label>
                  <Form.Control
                    type="text"
                    placeholder="Event Type Name"
                    name="name"
                    onChange={this.handleChange}
                  />
                  {this.validator.message(
                    "name",
                    this.state.name,
                    "required|alpha_space|max:30",
                    {
                      className: "text-danger",
                      messages: {
                        required: "The payment method name field is required.",
                        max: "The payment method name should not be greater than 30 characters.",
                        alpha_space:
                          "The payment method name must have valid characters.",
                      },
                    }
                  )}
                </Form.Group>
                <Form.Group
                  as={Col}
                  md="6"
                  controlId="exampleForm.ControlInput1"
                >
                  <Form.Label>Description</Form.Label>
                  <Form.Control
                    type="text"
                    placeholder="Description"
                    name="description"
                    onChange={this.handleChange}
                  />
                  {this.validator.message(
                    "description",
                    this.state.description,
                    "alpha_space|max:100",
                    {
                      className: "text-danger",
                      messages: {
                        max: "The payment method description should not be greater than 100 characters.",
                        alpha_space:
                          "The payment method description must have valid characters.",
                      },
                    }
                  )}
                </Form.Group>
              </Row>
            </Form>
          </Modal.Body>
          <Modal.Footer>
            <Button
              variant="primary"
              style={addBtnStyle}
              onClick={this.handleSubmit}
            >
              Save changes
            </Button>
            <Button
              id="modal-close-button"
              style={closeBtnStyle}
              onClick={() =>
                this.handleSweetAlert(
                  this.toggleAddPaymentMethodModal,
                  "showInsertModal"
                )
              }
            >
              Close
            </Button>
          </Modal.Footer>
        </Modal>

        <Modal
          size="lg"
          aria-labelledby="contained-modal-title-vcenter"
          centered
          show={this.state.showModal}
          onHide={() =>
            this.handleSweetAlert(this.toggleUpdatePaymentMethodModal, "showModal")
          }
        >
          <Modal.Header closeButton>
            <Modal.Title>Update Payment Method Information</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Form>
              <Row className="my-5">
                <Form.Group
                  as={Col}
                  md="6"
                  controlId="exampleForm.ControlInput1"
                >
                  <Form.Label>Payment Method Name *</Form.Label>
                  <Form.Control
                    type="text"
                    placeholder="Event Type Name"
                    name="name"
                    value={this.state.name}
                    onChange={this.handleChange}
                  />
                  {this.validator.message(
                    "name",
                    this.state.name,
                    "required|alpha_space|max:30",
                    {
                      className: "text-danger",
                      messages: {
                        required: "The payment method name field is required.",
                        max: "The payment method name should not be greater than 30 characters.",
                        alpha_space:
                          "The payment method name must have valid characters.",
                      },
                    }
                  )}
                </Form.Group>
                <Form.Group
                  as={Col}
                  md="6"
                  controlId="exampleForm.ControlInput1"
                >
                  <Form.Label>Description</Form.Label>
                  <Form.Control
                    type="text"
                    placeholder="Description"
                    name="description"
                    value={this.state.description}
                    onChange={this.handleChange}
                  />
                  {this.validator.message(
                    "description",
                    this.state.description,
                    "alpha_space|max:100",
                    {
                      className: "text-danger",
                      messages: {
                        max: "The payment method description should not be greater than 100 characters.",
                        alpha_space:
                          "The payment method description must have valid characters.",
                      },
                    }
                  )}
                </Form.Group>
              </Row>
            </Form>
          </Modal.Body>
          <Modal.Footer>
            <Button
              className="modal-btn"
              variant="primary"
              style={addBtnStyle}
              onClick={this.handleUpdateSubmit}
            >
              Save changes
            </Button>
            <Button
              className="modal-btn"
              id="modal-close-button"
              style={closeBtnStyle}
              onClick={() =>
                this.handleSweetAlert(this.toggleUpdatePaymentMethodModal, "showModal")
              }
            >
              Close
            </Button>
          </Modal.Footer>
        </Modal>

        <Modal
          size="lg"
          aria-labelledby="contained-modal-title-vcenter"
          centered
          show={this.state.showDetailModal}
          onHide={this.togglePaymentMethodDetailsModal}
        >
          <Modal.Header closeButton>
            <Modal.Title>Payment Method Details</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Form>
              <Row className="my-5">
                <Form.Group
                  as={Col}
                  md="6"
                  controlId="exampleForm.ControlInput1"
                >
                  <Form.Label>Payment Method Name</Form.Label>
                  <Form.Control type="text" placeholder="Payment Method Name" />
                </Form.Group>
                <Form.Group
                  as={Col}
                  md="6"
                  controlId="exampleForm.ControlInput1"
                >
                  <Form.Label>Description</Form.Label>
                  <Form.Control type="text" placeholder="Discription" />
                </Form.Group>
              </Row>
              <Row className="my-5">
                <Form.Group
                  as={Col}
                  md="6"
                  controlId="exampleForm.ControlInput2"
                >
                  <Form.Label>Status</Form.Label>
                  <Form.Select aria-label="Default select example">
                    <option>Select</option>
                    <option value="1">Active</option>
                    <option value="2">Deactive</option>
                  </Form.Select>
                </Form.Group>
              </Row>
            </Form>
          </Modal.Body>
          <Modal.Footer>
            <Button
              className="modal-btn"
              id="modal-close-button"
              style={closeBtnStyle}
              onClick={this.togglePaymentMethodDetailsModal}
            >
              Close
            </Button>
          </Modal.Footer>
        </Modal>
      </>
    );
  }
}
